{
  "yourReports": "Deine Reports",
  "selectReport": "Wähle einen Report",
  "myReport": "Mein Report",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "new": "Neu",
  "edit": "Anpassen",
  "transactions": "Transaktionen",
  "duplicate": "Duplizieren",
  "balances": "Salden",
  "history": "Historie",
  "howToUseReports": "Wie nutze ich Reports?",
  "switchToProjects": "Zur Projekt-Ansicht wechseln",
  "switchToDashboard": "Zur Dashboard-Ansicht wechseln",
  "tooltips": {
    "new": "Erstelle einen neuen Report",
    "edit": "Bearbeite den ausgewählten Report",
    "delete": "Lösche den ausgewählten Report",
    "duplicate": "Dupliziere den ausgewählten Report"
  }
}
